<template>
	<div class="ditem">
		<div class="ditem-title ditem-full">
			<object-link :src-id="duplicate.id" :src-type="SrcType.PARTY">{{ duplicate.fileAs }}</object-link>
		</div>
		<template v-if="duplicate.reason">
			<template v-if="reasonSplit > 0">
				<div class="ditem-info-label ditem-left">{{ reasonLabel }}:</div>
				<div class="ditem-info-value ditem-right">{{ reasonDescr }}</div>
			</template>
			<div v-else class="ditem-full ditem-reason">{{ duplicate.reason }}</div>
		</template>
		<div class="ditem-info-label ditem-left">{{ env.msg('th.entered') }}:</div>
		<div class="ditem-info-value ditem-right">{{ duplicate.entered }}{{ duplicate.enteredBy ? " (" + duplicate.enteredBy + ")" : "" }}</div>
		<div class="ditem-action ditem-full">
			<select class="action" v-model="actionIndex">
				<option value="-1">{{ env.msg('duplicates.solve') }}</option>
				<option v-for="(r, i) in duplicate.refactorings" v-html="r.title" :value="i"></option>
			</select>
		</div>
	</div>
</template>

<script setup lang="ts">
import ObjectLink from "./ObjectLink.vue";
import type {PartyDuplicate, PartyRefactoring} from "@t/customer/DuplicityChecker";
import {REFACTOR_LOCAL, REFACTOR_REDIR, REFACTOR_REMOTE} from "@t/customer/DuplicityChecker";
import type {PartyGraph} from "@t/customer/Customer";
import {SrcType} from "@t/meta/SourceType";
import {injectEnv} from "../Environment";
import {computed, ref, watch} from "vue";

const props = defineProps<{
	duplicate: PartyDuplicate,
	data: PartyGraph
}>();
const emit = defineEmits(["check"]);

const env = injectEnv();
const actionIndex = ref<number>(-1);

function applyRefactoring(rf: PartyRefactoring) {
	switch (rf.type) {
		case REFACTOR_LOCAL:
			//this.refactorLocal(ref);
			break;
		case REFACTOR_REMOTE:
			refactorRemote(rf);
			break;
		case REFACTOR_REDIR:
			refactorRedir(rf);
			break;
	}
}

const reasonSplit = computed(() => props.duplicate.reason.indexOf(':'));
const reasonLabel = computed(() => props.duplicate.reason.substring(0, reasonSplit.value).trim());
const reasonDescr = computed(() => props.duplicate.reason.substring(reasonSplit.value + 1).trim());

function refactorRemote(rf: PartyRefactoring) {
	env.net.fetch("refactorParty.do", "POST", rf)
		.then((resp) => {
			emit("check");
		});
}

function refactorRedir(rf: PartyRefactoring) {
	rf.params['graph'] = props.data;

	const frm = document.createElement("form");
	frm.setAttribute("method", "POST");
	frm.setAttribute("action", "refactorParty.do");
	frm.setAttribute("style", "display:none");
	document.body.appendChild(frm);
	const input = document.createElement("input");
	input.setAttribute("type", "hidden");
	input.setAttribute("name", "refactoring");
	input.setAttribute("value", JSON.stringify(rf));
	frm.appendChild(input);
	frm.submit();
}


watch(() => actionIndex.value, (n, o) => {
	if (n >= 0) {
		// Apply refactoring here
		applyRefactoring(props.duplicate.refactorings[n]);
	}
});
</script>

<style>
.ditem {
	display: grid;
	grid-template-columns: [distart] auto [dicenter] auto [diend];
	column-gap: 4px;
}

.ditem-title {
	font-weight: bold;
	margin-bottom:4px;
}
.ditem-action {
	margin-top:4px;
}

.ditem-full {
	grid-column: distart / diend;
}

.ditem-left {
	grid-column: distart / dicenter;
	opacity: 0.75;
}

.ditem-right {
	grid-column: dicenter / diend;
}
</style>